import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ServicesSection from './components/ServicesSection';
import ResourcesSection from './components/ResourcesSection';
import BlogSection from './components/BlogSection';
import AboutUs from './components/AboutUs';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ServicesSection />
      <ResourcesSection />
      <BlogSection />
      <AboutUs />
      <ContactSection />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;